import React, { useState, useEffect } from 'react';
import { parseISO, parse, format } from 'date-fns';
import { Button } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { makeStyles } from '@material-ui/core/styles';

import { firestore } from '../../utils/firebase';
import { deleteEntries } from '../../utils/api';

export const calculateHours = (minutes) => (minutes / 60).toFixed(1);

export const formatDate = (dateString) => {
  const date = parseISO(dateString);
  return format(date, 'M/d/yy');
};

export const formatTime = (timeString) => {
  const time = parse(timeString, 'HH:mm', new Date());
  return format(time, 'hh:mm a');
};

const useStyles = makeStyles((theme) => ({
  addEntry: {
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(2, 0),
    },
  },
}));

const TimeEntryTable = ({ userId, handleNewEntry, updateStatistics }) => {
  const columns = [
    { name: 'date', label: 'Date', options: { customBodyRender: formatDate } },
    { name: 'event', label: 'Event' },
    {
      name: 'start',
      label: 'Start Time',
      options: { customBodyRender: formatTime },
    },
    {
      name: 'end',
      label: 'End Time',
      options: { customBodyRender: formatTime },
    },
    {
      name: 'minutes',
      label: 'Hours',
      options: { customBodyRender: calculateHours },
    },
  ];

  const [entries, setEntries] = useState([]);

  const handleDeleteEntries = ({ data }) => {
    const idsToDelete = data.map((d) => entries[d.dataIndex].id);
    deleteEntries(userId, idsToDelete).then(() => {
      const remaining = entries.filter((e) => !idsToDelete.includes(e.id));
      setEntries(remaining);
      updateStatistics(remaining);
    });
  };

  const classes = useStyles();

  useEffect(() => {
    if (userId) {
      const unsubscribe = firestore
        .collection('users')
        .doc(userId)
        .collection('log')
        .orderBy('date', 'desc')
        .onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            const entries = querySnapshot.docs.map((d) => ({
              id: d.id,
              ...d.data(),
            }));
            setEntries(entries);
            updateStatistics(entries);
          }
        });

      return unsubscribe;
    }
  }, [userId]);

  const options = {
    download: false,
    search: false,
    print: false,
    filter: false,
    viewColumns: false,
    responsive: 'simple',
    // eslint-disable-next-line react/display-name
    customToolbar: () => (
      <Button
        className={classes.addEntry}
        variant="contained"
        color="primary"
        onClick={handleNewEntry}
      >
        Add Entry
      </Button>
    ),
    textLabels: {
      body: {
        noMatch:
          "No records found. Add one now by clicking the 'Add Entry' button.",
      },
    },
    onRowsDelete: handleDeleteEntries,
  };

  return (
    <MUIDataTable
      title={'Time Log'}
      data={entries}
      columns={columns}
      options={options}
    />
  );
};

export default TimeEntryTable;
